class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Remove hidden display
    document.querySelector('.cart-notification-wrapper').style.display = 'block';

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') {
        this.updateCartCount(parsedState.sections[section.id]);
      } else {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }

      if (section.id === 'cart-notification-button') {
        const icon = document.createElement('svg');
        icon.innerHTML = `
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" height="16px" width="16px">
            <title>{{ 'icon-g</title>
            <g fill-rule="evenodd" fill="none" stroke="none" id="Money-/-Shopping">
                <path fill="currentColor" id="Color" d="M12,0 C14.1421954,0 15.8910789,1.68396847 15.9951047,3.80035966 L16,4 L15.9990976,5 L20.0540135,5 C20.5847472,5 21.0230341,5.41461342 21.0524739,5.94452998 L21.9413628,21.94453 C21.971998,22.4959644 21.5498069,22.9678251 20.9983724,22.9984604 L20.9429024,23 L3.05709758,23 C2.50481283,23 2.05709758,22.5522847 2.05709758,22 C2.05709758,21.9814993 2.05761099,21.9630022 2.05863722,21.94453 L2.94752611,5.94452998 C2.97696592,5.41461342 3.41525276,5 3.94598647,5 L7.99909758,5 L8,4 C8,1.790861 9.790861,0 12,0 Z M7.99909758,7 L5.94476888,7 C5.41453166,7 4.97647371,7.41386351 4.94638068,7.94324609 L4.2041626,21 L19.8,21 L19.0538829,7.94295021 C19.0236395,7.41369079 18.5856343,7 18.0555115,7 L15.9990976,7 L16,9 C16,9.66666667 15.6666667,10 15,10 C14.3333333,10 14,9.66666667 14,9 L13.9990976,7 L9.99909758,7 L10,9 C10,9.66666667 9.66666667,10 9,10 C8.33333333,10 8,9.66666667 8,9 L7.99909758,7 Z M12,2 C10.9456382,2 10.0818349,2.81587779 10.0054857,3.85073766 L10,4 L9.99909758,5 L13.9990976,5 L14,4 C14,2.8954305 13.1045695,2 12,2 Z"></path>
            </g>
          </svg>
        `;
        document.getElementById(section.id).prepend(icon);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  updateCartCount(html) {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // The HTML from Shopify includes the full section wrapped in .shopify-section
    // We need to find the .cart-count-bubble div which contains the count
    const shopifySection = tempDiv.querySelector('.shopify-section');
    let cartCountBubbleInHTML = null;
    
    if (shopifySection) {
      cartCountBubbleInHTML = shopifySection.querySelector('.cart-count-bubble');
    } else {
      cartCountBubbleInHTML = tempDiv.querySelector('.cart-count-bubble');
    }
    
    // Now look for the count element inside the cart-count-bubble
    let newCountElement = null;
    let newScreenReaderElement = null;
    
    if (cartCountBubbleInHTML) {
      newCountElement = cartCountBubbleInHTML.querySelector('[aria-hidden="true"]');
      newScreenReaderElement = cartCountBubbleInHTML.querySelector('.visually-hidden');
    } else {
      // Fallback: try to find directly in the HTML
      newCountElement = tempDiv.querySelector('[aria-hidden="true"]');
      newScreenReaderElement = tempDiv.querySelector('.visually-hidden');
    }
    
    if (newCountElement) {
      const currentCountElement = cartBubble.querySelector('[aria-hidden="true"]');
      if (currentCountElement) {
        currentCountElement.textContent = newCountElement.textContent;
      } else {
        // If the count element doesn't exist, create it
        const countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        countSpan.textContent = newCountElement.textContent;
        cartBubble.appendChild(countSpan);
      }
      
      const currentScreenReaderElement = cartBubble.querySelector('.visually-hidden');
      if (currentScreenReaderElement && newScreenReaderElement) {
        currentScreenReaderElement.textContent = newScreenReaderElement.textContent;
      } else if (newScreenReaderElement && !currentScreenReaderElement) {
        const screenReaderSpan = document.createElement('span');
        screenReaderSpan.className = 'visually-hidden';
        screenReaderSpan.textContent = newScreenReaderElement.textContent;
        cartBubble.appendChild(screenReaderSpan);
      }
      
      // Make sure the bubble is visible
      cartBubble.style.display = '';
    } else {
      // Cart is empty - clear the bubble content completely (including whitespace)
      while (cartBubble.firstChild) {
        cartBubble.removeChild(cartBubble.firstChild);
      }
      // The CSS :empty selector will handle hiding the bubble when it has no content
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);